export const ROOT_PATH = "/";

export const LOGIN_PATH = `${ROOT_PATH}login`;
export const PROFILE_PATH = `${ROOT_PATH}profile`;

// products
export const PRODUCT_LIST_PATH = `${ROOT_PATH}product-list`;
export const ADD_PRODUCT_PATH = `${ROOT_PATH}add-product`;
export const EDIT_PRODUCT_PATH = `${ROOT_PATH}edit-product`;
export const DETAILS_PRODUCT_PATH = `${ROOT_PATH}product-details`;
// stores
export const STORE_LIST_PATH = `${ROOT_PATH}store-list`;
export const ADD_STORE_PATH = `${ROOT_PATH}add-store`;
export const EDIT_STORE_PATH = `${ROOT_PATH}edit-store`;

// generic
export const GENERIC_LIST_PATH = `${ROOT_PATH}generic-list`;
export const ADD_GENERIC_PATH = `${ROOT_PATH}add-generic`;
export const EDIT_GENERIC_PATH = `${ROOT_PATH}edit-generic`;

// customer
export const CUSTOMER_LIST_PATH = `${ROOT_PATH}customer-list`;
export const ADD_CUSTOMER_PATH = `${ROOT_PATH}add-customer`;
export const EDIT_CUSTOMER_PATH = `${ROOT_PATH}edit-customer`;
// customer transaction
export const CUSTOMER_TRANSACTION_LIST_PATH = `${ROOT_PATH}customer-transaction-list`;
export const ADD_CUSTOMER_TRANSACTION_PATH = `${ROOT_PATH}add-customer-transaction`;
export const EDIT_CUSTOMER_TRANSACTION_PATH = `${ROOT_PATH}edit-customer-transaction`;

// supplier
export const SUPPLIER_LIST_PATH = `${ROOT_PATH}supplier-list`;
export const ADD_SUPPLIER_PATH = `${ROOT_PATH}add-supplier`;
export const EDIT_SUPPLIER_PATH = `${ROOT_PATH}edit-supplier`;

// user
export const USER_LIST_PATH = `${ROOT_PATH}user-list`;
export const ADD_USER_PATH = `${ROOT_PATH}add-user`;
export const EDIT_USER_PATH = `${ROOT_PATH}edit-user`;

// suit
export const SUIT_LIST_PATH = `${ROOT_PATH}suit-list`;
export const ADD_SUIT_PATH = `${ROOT_PATH}add-suit`;
export const EDIT_SUIT_PATH = `${ROOT_PATH}edit-suit`;

// banner
export const BANNER_LIST_PATH = `${ROOT_PATH}banner-list`;
export const ADD_BANNER_PATH = `${ROOT_PATH}add-banner`;
export const EDIT_BANNER_PATH = `${ROOT_PATH}edit-banner`;

// suit
export const TEAM_MEMBER_LIST_PATH = `${ROOT_PATH}team-member-list`;
export const ADD_TEAM_MEMBER_PATH = `${ROOT_PATH}add-team-member`;
export const EDIT_TEAM_MEMBER_PATH = `${ROOT_PATH}edit-team-member`;

// tribute
export const TRIBUTE_LIST_PATH = `${ROOT_PATH}tribute-list`;
export const ADD_TRIBUTE_PATH = `${ROOT_PATH}add-tribute`;
export const EDIT_TRIBUTE_PATH = `${ROOT_PATH}edit-tribute`;

// Activity
export const ACTIVITY_LIST_PATH = `${ROOT_PATH}activity-list`;
export const ADD_ACTIVITY_PATH = `${ROOT_PATH}add-activity`;
export const EDIT_ACTIVITY_PATH = `${ROOT_PATH}edit-activity`;

// Comlimentary
export const COMPLIMENTARY_LIST_PATH = `${ROOT_PATH}complimentary-list`;
export const ADD_COMPLIMENTARY_PATH = `${ROOT_PATH}add-complimentary`;
export const EDIT_COMPLIMENTARY_PATH = `${ROOT_PATH}edit-complimentary`;

// Accommodation
export const ACCOMMODATION_LIST_PATH = `${ROOT_PATH}accommodation-list`;
export const ADD_ACCOMMODATION_PATH = `${ROOT_PATH}add-accommodation`;
export const EDIT_ACCOMMODATION_PATH = `${ROOT_PATH}edit-accommodation`;

// sale
export const SALE_LIST_PATH = `${ROOT_PATH}sale-list`;
export const ADD_SALE_PATH = `${ROOT_PATH}add-sale`;
export const EDIT_SALE_PATH = `${ROOT_PATH}edit-sale`;
export const SALE_RECORD_PATH = `${ROOT_PATH}sale-record`;
export const SALE_DETAILS_PATH = `${ROOT_PATH}sale-details`;
// purchase
export const SALE_PURCHASE_PATH = `${ROOT_PATH}purchase-list`;
export const ADD_PURCHASE_PATH = `${ROOT_PATH}add-purchase`;
export const EDIT_PURCHASE_PATH = `${ROOT_PATH}edit-purchase`;
export const PURCHASE_RECORD_PATH = `${ROOT_PATH}purchase-record`;
export const PURCHASE_DETAILS_PATH = `${ROOT_PATH}purchase-details`;
// role
export const ROLE_LIST_PATH = `${ROOT_PATH}role-list`;
export const ADD_ROLE_PATH = `${ROOT_PATH}add-role`;
export const EDIT_ROLE_PATH = `${ROOT_PATH}edit-role`;

// static page
export const STATIC_PAGE_LIST_PATH = `${ROOT_PATH}static-page-list`;
export const ADD_STATIC_PAGE_PATH = `${ROOT_PATH}add-static-page`;
export const EDIT_STATIC_PAGE_PATH = `${ROOT_PATH}edit-static-page`;

// customer feedback
export const CUSTOMER_FEEDBACK_LIST_PATH = `${ROOT_PATH}customer-feedback-list`;

// site config
export const SITE_CONFIG_LIST_PATH = `${ROOT_PATH}site-config-list`;
export const ADD_SITE_CONFIG_PATH = `${ROOT_PATH}add-site-config`;
export const EDIT_SITE_CONFIG_PATH = `${ROOT_PATH}edit-site-config`;

// home content
export const HOME_CONTENT_LIST_PATH = `${ROOT_PATH}home-content-list`;
export const ADD_HOME_CONTENT_PATH = `${ROOT_PATH}add-home-content`;
export const EDIT_HOME_CONTENT_PATH = `${ROOT_PATH}edit-home-content`;

// about content
export const ABOUT_CONTENT_LIST_PATH = `${ROOT_PATH}about-content-list`;
export const ADD_ABOUT_CONTENT_PATH = `${ROOT_PATH}add-about-content`;
export const EDIT_ABOUT_CONTENT_PATH = `${ROOT_PATH}edit-about-content`;

// promotion
export const PROMOTION_LIST_PATH = `${ROOT_PATH}promotion-list`;
export const ADD_PROMOTION_PATH = `${ROOT_PATH}add-promotion`;
export const EDIT_PROMOTION_PATH = `${ROOT_PATH}edit-promotion`;

// blog
export const BLOG_LIST_PATH = `${ROOT_PATH}blog-list`;
export const ADD_BLOG_PATH = `${ROOT_PATH}add-blog`;
export const EDIT_BLOG_PATH = `${ROOT_PATH}edit-blog`;

// package
export const PACKAGE_LIST_PATH = `${ROOT_PATH}package-list`;
export const ADD_PACKAGE_PATH = `${ROOT_PATH}add-package`;
export const EDIT_PACKAGE_PATH = `${ROOT_PATH}edit-package`;

export const PAGE_403_PATH = `${ROOT_PATH}403`;
export const PAGE_404_PATH = `${ROOT_PATH}404`;
export const PAGE_500_PATH = `${ROOT_PATH}500`;

// Booking
export const BOOKING_LIST_PATH = `${ROOT_PATH}booking-list`;
export const EDIT_BOOKING_PATH = `${ROOT_PATH}edit-booking`;
export const BOOKING_DETAILS_PATH = `${ROOT_PATH}booking-details`;
// category

export const CATEGORY_LIST_PATH = `${ROOT_PATH}category-list`;
export const ADD_CATEGORY_PATH = `${ROOT_PATH}add-category`;
export const EDIT_CATEGORY_PATH = `${ROOT_PATH}edit-category`;
// factory

export const FACTORY_LIST_PATH = `${ROOT_PATH}factory-list`;
export const ADD_FACTORY_PATH = `${ROOT_PATH}add-factory`;
export const EDIT_FACTORY_PATH = `${ROOT_PATH}edit-factory`;
// product capacity
export const PRODUCT_CAPACITY_LIST_PATH = `${ROOT_PATH}product-capacity-list`;
export const ADD_PRODUCT_CAPACITY_PATH = `${ROOT_PATH}add-product-capacity`;
export const EDIT_PRODUCT_CAPACITY_PATH = `${ROOT_PATH}edit-product-capacity`;

// product items
export const PRODUCT_ITEM_LIST_PATH = `${ROOT_PATH}product-list`;
export const ADD_PRODUCT_ITEM_PATH = `${ROOT_PATH}add-product`;
export const EDIT_PRODUCT_ITEM_PATH = `${ROOT_PATH}edit-product`;

// testimonials
export const TESTIMONIAL_LIST_PATH = `${ROOT_PATH}testimonial-list`;
export const ADD_TESTIMONIAL_PATH = `${ROOT_PATH}add-testimonial`;
export const EDIT_TESTIMONIAL_PATH = `${ROOT_PATH}edit-testimonial`;

// buyer
export const BUYER_LIST_PATH = `${ROOT_PATH}buyer-list`;
export const ADD_BUYER_PATH = `${ROOT_PATH}add-buyer`;
export const EDIT_BUYER_PATH = `${ROOT_PATH}edit-buyer`;

// factory options
export const FACTORY_OPTIONS_LIST_PATH = `${ROOT_PATH}factory-options-list`;

// buying partners
export const BUYING_PARTNERS_LIST_PATH = `${ROOT_PATH}buying-partners-list`;

// careers
export const CAREER_LIST_PATH = `${ROOT_PATH}career-list`;
export const ADD_CAREER_PATH = `${ROOT_PATH}add-career`;
export const EDIT_CAREER_PATH = `${ROOT_PATH}edit-career`;

// sustainability
export const SUSTAINABILITY_PAGE_PATH = `${ROOT_PATH}sustainability-page`;

// factory certifications
export const FACTORY_CERTIFICATIONS_PAGE_PATH = `${ROOT_PATH}factory-certifications-page`;

// SLUGS_EXPORTS_AREA
